import { __awaiter, __generator } from "tslib";
export var createIconDriver = function (wrapper) {
    var base = wrapper.$('.icon');
    return {
        hasColorOverride: function () { return base.hasClass('has-color-override'); },
        ariaHidden: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, base.attr('aria-hidden')];
                case 1: return [2 /*return*/, !!(_a.sent())];
            }
        }); }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map